import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock';

export default {
  methods: {
    toggleSiteDrawer(reference) {
      const target = this.$root.$refs[reference].scrollTarget ? document.querySelector(this.$root.$refs[reference].scrollTarget) : this.$root.$refs[reference].$refs['target']

      this.$root.$refs[reference].open = !this.$root.$refs[reference].open

      if (this.$root.$refs[reference].open) {
        disableBodyScroll(target, {
          reserveScrollBarGap: false,
        })
      } else {
        enableBodyScroll(target, {
          reserveScrollBarGap: false
        })
      }
    },
    closeSiteDrawer(reference) {
      const target = this.$root.$refs[reference].scrollTarget ? document.querySelector(this.$root.$refs[reference].scrollTarget) : this.$root.$refs[reference].$refs['target']

      this.$root.$refs[reference].open = false

      enableBodyScroll(target, {
        reserveScrollBarGap: false
      })
    },
    openSiteDrawer(reference) {
      const target = this.$root.$refs[reference].scrollTarget ? document.querySelector(this.$root.$refs[reference].scrollTarget) : this.$root.$refs[reference].$refs['target']
      
      this.$root.$refs[reference].open = true

      disableBodyScroll(target, {
        reserveScrollBarGap: false,
      })
    }
  }
}